import { render } from "./iconImage.vue?vue&type=template&id=acced444&scoped=true"
import script from "./iconImage.vue?vue&type=script&lang=js"
export * from "./iconImage.vue?vue&type=script&lang=js"

import "./iconImage.vue?vue&type=style&index=0&id=acced444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acced444"]])

export default __exports__